export default {
  fileSizeError: 'Please upload a file smaller than 5MB',
  fileTypeError: 'File type not supported',
  totalFileSizeError: 'Please upload less than 9MB in total',
  attachmentButtonAriaLabel: 'Add Attachment',
};
